import { render, staticRenderFns } from "./invoiceTable.vue?vue&type=template&id=384c2ad3&scoped=true&"
import script from "./invoiceTable.vue?vue&type=script&lang=js&"
export * from "./invoiceTable.vue?vue&type=script&lang=js&"
import style0 from "./invoiceTable.vue?vue&type=style&index=0&id=384c2ad3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384c2ad3",
  null
  
)

export default component.exports